let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7ylp3"), load("kIPUL"), load("aZinD"), load("6qah4"), load("daCl8"), load("dGFK7")]).then(() => parcelRequire('gxWFp'));